import { Box, Typography } from '@mui/material';
import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { LineItem, Image } from 'components';

const EarnItemDetails = ({ earnItem }) => (
	<List>
		<LineItem label="Name" value={earnItem.name} />
		<LineItem label="Type" value={earnItem.item} />
		<LineItem label="Coins" value={earnItem.coins} />
		<LineItem label="XP" value={earnItem.xp} />
	</List>
);

export default EarnItemDetails;
